import { useParams } from 'react-router-dom'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { BillingTypeBuyOptionModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeBuy/billingTypeBuyOption'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import { MediumModalCreateEdit } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import useBillingDictTypes from '../../../../../../../../utils/hooks/billingGroups/useBillingDictTypes'


interface ModalCEConfigBillingTypeBuyOptionProps extends ModalEditComponentProps { }

const ModalCEConfigBillingTypeBuyOption: React.FC<ModalCEConfigBillingTypeBuyOptionProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { BillingTypeBuyId } = useParams()
    const { dictTypeBilling, dictImportType, dictRetentionType, dictVatSupportedType } = useBillingDictTypes()
    const fields: FormRender<BillingTypeBuyOptionModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'typeBilling',
                    label: t('typeBilling', 'Tipo de Facturación'),
                    component: 'CustomSelect',
                    items: dictTypeBilling,
                    required: true
                },
                {
                    name: 'import',
                    label: t('import', 'Importación'),
                    component: 'CustomSelect',
                    items: dictImportType,
                    required: true
                },
                {
                    name: 'retention',
                    label: t('retention', 'Retención'),
                    component: 'CustomSelect',
                    items: dictRetentionType,
                    required: true
                },
                {
                    name: 'withVat',
                    label: t('withVatSupported', 'Con IVA Soportado'),
                    component: 'CustomSelect',
                    items: dictVatSupportedType,
                    required: true
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                },
                {
                    name: 'BillingTypeBuyId',
                    component: 'InputHidden',
                    value: BillingTypeBuyId
                },

            ]
        }
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (
            <MediumModalCreateEdit fields={parsedFields} url={'/api/app/config/billingGroup/billingTypeBuy/option/updateBillingTypeBuyOption'} translations={{ title: t('editBillingTypeBuyOption', 'Editar Opción de Facturación') + ' - ' + allRowData?.['name'], button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />
        )
    }
    return (
        <MediumModalCreateEdit fields={fields} url={'/api/app/config/billingGroup/billingTypeBuy/option/createBillingTypeBuyOption'} translations={{
            title: t('createBillingTypeBuyOption', 'Crear opción de facturación'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} />
    )
}

export default ModalCEConfigBillingTypeBuyOption